export enum ResourceType {
    BookingEngine = "booking_engine",
    Integration = "integration",
}
